import { baseResources, baseResourceActions } from "routes/enum";

const { AUTOMATION } = baseResources;
const { READ, CREATE, UPDATE, DELETE } = baseResourceActions;

/** View automations */
export const AUTOMATION_READ_PERMISSION = [`${READ}_${AUTOMATION}`];

/** Create automation */
export const AUTOMATION_CREATE_PERMISSION = [`${CREATE}_${AUTOMATION}`];

/** Edit automation */
export const AUTOMATION_UPDATE_PERMISSION = [`${UPDATE}_${AUTOMATION}`];

/** Delete automation */
export const AUTOMATION_DELETE_PERMISSION = [`${DELETE}_${AUTOMATION}`];

export const AUTOMATION_WRITE_PERMISSION = [
    ...AUTOMATION_CREATE_PERMISSION,
    ...AUTOMATION_UPDATE_PERMISSION,
];

export const AUTOMATION_PERMISSION_MAP = {
    "View automations": AUTOMATION_READ_PERMISSION,
    "Create automation": AUTOMATION_CREATE_PERMISSION,
    "Edit automation": AUTOMATION_UPDATE_PERMISSION,
    "Delete automation": AUTOMATION_DELETE_PERMISSION,
};
